export default __webpack_public_path__ + "locales/zh-CN/BackupCodesDialog.json?hash=c92fe025b35153db772b02c4be762647";